// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Στήλη sidebar */
.sidebar-col {
    display: flex;
    flex-direction: column;
    min-height: 0;
}

/* Κάρτα */
.sidebar-card {
    flex: 1 1;
    min-height: 0;
    display: flex;
}

/* CardBody: column layout, ΧΩΡΙΣ scroll εδώ */
.sidebar-body {
    flex: 1 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

/* 🟩 Η λίστα: ΠΡΕΠΕΙ να γεμίζει και να έχει overflow */
.sidebar-scroll {
    flex: 1 1 auto;
    /* <-- κρίσιμο: παίρνει ύψος */
    min-height: 0;
    /* <-- επιτρέπει στο flex child να "σπάσει" */
    overflow-y: auto;
    /* <-- εδώ η μπάρα */
    overflow-x: hidden;
    display: flex !important;
    flex-direction: column !important;
    flex-wrap: nowrap !important;
}

/* Container του selector */
.occ-col {
    min-height: 0;
    padding-right: .5rem;
    padding-left: .5rem;
    margin-right: 16px;
    margin-left: 8px;
    padding-top: 5px;
    display: flex;
    flex-direction: column;
}

/* Μετά το header (search), η λίστα να γεμίζει */
.occ-col>.row+* {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

/* Απλό wrapper – ΔΕΝ βάζουμε scroll εδώ */
.occ-scroll {
    flex: 1 1 auto;
    min-height: 0;
    display: block;
}

/* Προαιρετικό: τα negative margins του .row μπορεί να πετάνε οριζόντια μπάρα */
.row.sidebar-scroll {
    margin-left: 0 !important;
    margin-right: 0 !important;
}

@media (max-width:768px) {
    .sidebar-col {
        margin-bottom: 12px;
    }
}



/* το ύψος του .sidebar-scroll το βάζει JS inline */
.sidebar-scroll {
    min-height: 0 !important;
}

/* κόψε τα negative margins του .row */
.row.sidebar-scroll {
    margin-left: 0 !important;
    margin-right: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/views/industry/advertisements/LeftCard/sidebar.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA,UAAU;AACV;IACI,SAAO;IACP,aAAa;IACb,aAAa;AACjB;;AAEA,8CAA8C;AAC9C;IACI,SAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,uDAAuD;AACvD;IACI,cAAc;IACd,8BAA8B;IAC9B,aAAa;IACb,6CAA6C;IAC7C,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,wBAAwB;IACxB,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA,gDAAgD;AAChD;IACI,cAAc;IACd,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA,0CAA0C;AAC1C;IACI,cAAc;IACd,aAAa;IACb,cAAc;AAClB;;AAEA,+EAA+E;AAC/E;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;;;AAIA,mDAAmD;AACnD;IACI,wBAAwB;AAC5B;;AAEA,sCAAsC;AACtC;IACI,yBAAyB;IACzB,0BAA0B;AAC9B","sourcesContent":["/* Στήλη sidebar */\n.sidebar-col {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n}\n\n/* Κάρτα */\n.sidebar-card {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n}\n\n/* CardBody: column layout, ΧΩΡΙΣ scroll εδώ */\n.sidebar-body {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n/* 🟩 Η λίστα: ΠΡΕΠΕΙ να γεμίζει και να έχει overflow */\n.sidebar-scroll {\n    flex: 1 1 auto;\n    /* <-- κρίσιμο: παίρνει ύψος */\n    min-height: 0;\n    /* <-- επιτρέπει στο flex child να \"σπάσει\" */\n    overflow-y: auto;\n    /* <-- εδώ η μπάρα */\n    overflow-x: hidden;\n    display: flex !important;\n    flex-direction: column !important;\n    flex-wrap: nowrap !important;\n}\n\n/* Container του selector */\n.occ-col {\n    min-height: 0;\n    padding-right: .5rem;\n    padding-left: .5rem;\n    margin-right: 16px;\n    margin-left: 8px;\n    padding-top: 5px;\n    display: flex;\n    flex-direction: column;\n}\n\n/* Μετά το header (search), η λίστα να γεμίζει */\n.occ-col>.row+* {\n    flex: 1 1 auto;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n}\n\n/* Απλό wrapper – ΔΕΝ βάζουμε scroll εδώ */\n.occ-scroll {\n    flex: 1 1 auto;\n    min-height: 0;\n    display: block;\n}\n\n/* Προαιρετικό: τα negative margins του .row μπορεί να πετάνε οριζόντια μπάρα */\n.row.sidebar-scroll {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n}\n\n@media (max-width:768px) {\n    .sidebar-col {\n        margin-bottom: 12px;\n    }\n}\n\n\n\n/* το ύψος του .sidebar-scroll το βάζει JS inline */\n.sidebar-scroll {\n    min-height: 0 !important;\n}\n\n/* κόψε τα negative margins του .row */\n.row.sidebar-scroll {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
